import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type DecisionDashboard } from '../../api/decision';

const NAV = [
  { to: '/decision', label: 'Executive Decision Center' },
  { to: '/decision/recommendations', label: 'Recommendation Center' },
  { to: '/decision/simulations', label: 'Simulation Studio' },
  { to: '/decision/optimizations', label: 'Optimization Center' },
  { to: '/decision/agents', label: 'AI Agent Console' },
  { to: '/decision/timeline', label: 'Decision Timeline' },
  { to: '/decision/risk', label: 'Risk Dashboard' },
  { to: '/decision/approvals', label: 'Approval Dashboard' },
  { to: '/decision/cockpit', label: 'Executive Cockpit' },
];

export function DecisionHubPage() {
  const [dashboard, setDashboard] = useState<DecisionDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void decisionApi.dashboard((getWorkspaceId() ?? '')).then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total Decisions', value: dashboard.total_decisions },
        { label: 'Pending Approvals', value: dashboard.pending_approvals },
        { label: 'Open Recommendations', value: dashboard.open_recommendations },
        { label: 'Active Optimizations', value: dashboard.active_optimizations },
        { label: 'Active Agents', value: dashboard.active_agents },
        { label: 'Avg Confidence', value: `${(dashboard.avg_confidence * 100).toFixed(0)}%` },
        { label: 'High Risk', value: dashboard.high_risk_decisions },
        { label: 'Autonomous Executions', value: dashboard.autonomous_executions },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">Executive Decision Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise AI decision engine, autonomous commerce agents and strategic optimization platform.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-indigo-700 hover:underline dark:text-indigo-400">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
